import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrimeReactProvider } from 'primereact/api';

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import 'primereact/resources/primereact.css';

import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import '../src/css/GlobalOverrides.css';


import Menu from './pages/Menu';
import Login from './pages/Login';
import Register from './pages/Register';
import Usuario from './pages/Usuario';
import Permisos from './pages/Permisos';
import Perfil from './pages/Perfil';
import Dashboard from './pages/Dashboard';
import NotFoundPage from './pages/NotFoundPage';
import Personas from './pages/General/Personas';
import { LocalView } from './pages/LocalView';
import { AdminLocales } from './pages/AdminLocales';
import { DashboardElectoral } from './pages/DashboardElectoral';



function App() {
  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route exact path="/" element={<Menu />} >
              {/* Rutas Iniciales */}
              <Route exact path="/usuario" element={<Usuario />} />
              <Route exact path="/permisos" element={<Permisos />} />
              <Route exact path="/perfil" element={<Perfil />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path='notfound' element={<NotFoundPage />} />
              {/* Fin de Rutas Iniciales */}
              {/* Rutas Generales */}
              <Route exact path='/personas' element={<Personas />} />
              <Route exact path='/localview' element={<LocalView />} />
              <Route exact path='/adminlocales' element={<AdminLocales />} />
              <Route exact path='/dashboardelectoral' element={<DashboardElectoral />} />
              {/* Fin de Rutas Generales */}
            </Route>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/register" element={<Register />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;

